import {GetLoadables} from './loader'

// #if process.env.UIX_CHUNKED === 'true'
let loader = () => {
  return import(/* webpackChunkName: 'jsontree' */ './jsontreeLoad')
}
const L = GetLoadables(loader, ['JSONTree', 'SearchableJSONTree'])
// #endif

// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './jsontreeLoad'
// #endif

export let {JSONTree, SearchableJSONTree} = L
